module.exports = __webpack_public_path__ + "img/badge-3.92dcbedf.svg";